(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingSettingsDeleteController',SeekingSettingsDeleteController);

    SeekingSettingsDeleteController.$inject = ['$uibModalInstance', 'entity', 'SeekingSettings'];

    function SeekingSettingsDeleteController($uibModalInstance, entity, SeekingSettings) {
        var vm = this;

        vm.seekingSettings = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SeekingSettings.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
